import { gql } from '@apollo/client'

export const REMOVE_COMPANY_GROUP = gql`
  mutation RemoveCompanyGroup($id: ID!) {
    removeGroup(id: $id)
  }
`
